// extracted by mini-css-extract-plugin
export default {"permissionModal":"CPUManagementForm_permissionModal__FJdNy","k-card":"CPUManagementForm_k-card__4q3tP"};